import React from 'react';
import './LandingPage.css';
import ramada from '../assets/ramada.jpg';
import mrgamb from '../assets/mrgamb.png';
import bellaProfile from '../assets/bella.jpg';

const LandingPage = () => {
  // Ana yönlendirme kutuları
  const mainBoxes = [
    {
      id: 1,
      imageUrl: mrgamb,
      link: 'https://tinyurl.com/MrsBellaa',
      title: 'Mr. Gamb'
    }
  ];

  // Sosyal medya linkleri (küçük ikonlar)
  const socialLinks = [
    {
      id: 1,
      name: 'Instagram',
      url: 'https://www.instagram.com/bella_winxx?igsh=MXh3bnUwOXVsOTB4Ng%3D%3D&utm_source=qr',
      icon: 'https://cdn-icons-png.flaticon.com/512/174/174855.png',
      color: '#E4405F'
    },
    {
      id: 2,
      name: 'Youtube',
      url: 'https://youtube.com/@bellawnx?feature=shared',
      icon: 'https://cdn-icons-png.flaticon.com/512/174/174883.png',
      color: '#E4405F'
    },
    {
      id: 4,
      name: 'Telegram',
      url: 'https://t.me/bellawinx2',
      icon: 'https://cdn-icons-png.flaticon.com/512/2111/2111646.png',
      color: '#0088CC'
    },
    {
      id: 5,
      name: 'Telegram Sohbet',
      url: 'https://t.me/bellasohbet',
      icon: 'https://cdn-icons-png.flaticon.com/512/2111/2111646.png',
      color: '#0088CC'
    },
    {
      id: 6,
      name: 'TikTok',
      url: 'https://www.tiktok.com/@bella.winx6?_t=ZM-8zMjbwQgF41&_r=1',
      icon: 'https://cdn-icons-png.flaticon.com/512/3046/3046121.png',
      color: '#000000'
    }
  ];

  const handleClick = (url) => {
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  return (
    <div className="landing-page">
      {/* BELLA Başlığı ve Profil Fotoğrafı */}
      <div className="bella-title-container">
        <div className="bella-header">
          <div className="bella-profile-container">
            <img
              src={bellaProfile}
              alt="Bella Profile"
              className="bella-profile-image"
            />
          </div>
          <div className="bella-text-section">
            <h1 className="bella-title">BELLA</h1>
            <p className="bella-subtitle">Güvenilir ve Kaliteli Hizmet</p>
          </div>
        </div>
      </div>

      {/* Ana yönlendirme kutuları üstte */}
      <div className="main-boxes-container">
        {mainBoxes.map(box => (
          <div
            key={box.id}
            className="main-box"
            onClick={() => handleClick(box.link)}
            style={{ backgroundImage: `url(${box.imageUrl})` }}
          >
            <div className="main-box-overlay">
              <h3 className="main-box-title">{box.title}</h3>
              <span className="main-box-arrow">→</span>
            </div>
          </div>
        ))}
      </div>

      {/* Sosyal medya ikonları altta (küçük) */}
      <div className="social-icons-bar">
        {socialLinks.map(link => (
          <div
            key={link.id}
            className="social-icon-item"
            onClick={() => handleClick(link.url)}
            style={{ '--hover-color': link.color }}
            title={link.name}
          >
            <img
              src={link.icon}
              alt={link.name}
              className="social-small-icon"
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default LandingPage;
